import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {
  LoginLink,
  RegisterLogin,
} from 'Containers/CreateCampaignWithoutSignup/components/UserRegisterForm/styles'
import { ErrorTextBlock, Input, Label } from './style'
import { CustomInputWithLabelProps } from './CustomInputWithLabelProps'

export const CustomInputWithLabel: FC<CustomInputWithLabelProps> = ({
  error,
  inputValue,
  labelText,
  inputAttributes,
  register,
  isShowError,
}) => {
  const { t } = useTranslation()
  return (
    <div>
      {inputValue && (
        <Label htmlFor={inputAttributes.name} isError={Boolean(error)}>
          {t(labelText)}
        </Label>
      )}
      <Input
        isError={Boolean(error)}
        type="text"
        {...inputAttributes}
        {...register?.(inputAttributes.name)}
      />
      {isShowError && error && (
        <>
          <ErrorTextBlock>
            <p>{error}</p>
            {error === t('createCampaignPage.useAnotherEmailToRegisterOr') && (
              <LoginLink href="https://app.soundcamps.com/">
                <RegisterLogin>
                  {t('createCampaignPage.loginWithYourAccount')}
                </RegisterLogin>
              </LoginLink>
            )}
          </ErrorTextBlock>
        </>
      )}
    </div>
  )
}
